import { SEO } from "components/core/seo"
import { Spinner } from "components/core/spinner"
import { Account } from "components/user/account"
import { getProducts } from "lib/stripe/ssrData"
import { BASE_URL } from "lib/utils"
import { GetStaticProps, NextPage } from "next"
import React, { useEffect, useState } from "react"
import { Stripe } from "stripe"

interface Props {
  products: Stripe.Product[]
}

const AccountPage: NextPage<Props> = ({ products }) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return (
      <div className="h-full w-full flex items-center justify-center">
        <Spinner className="w-10 h-10 text-indigo-600 dark:text-indigo-400" />
      </div>
    )
  }

  return (
    <>
      <SEO
        title="Account"
        description="Frontend Toolkit offers customizable dashboards for your recurring Frontend tasks. Base64 encoder/decoder, SVG optimizations, SVG to JSX and many more!"
        ogImage={{
          title: "Account",
          url: `${BASE_URL}/account`,
        }}
      />
      {products && <Account products={products} />}
    </>
  )
}

export const getStaticProps: GetStaticProps<Props> = async () => {
  const products = await getProducts()

  return {
    props: {
      products,
    },
  }
}

export default AccountPage
